module.exports = __webpack_public_path__ + "static/media/pentagon.0a7a616d.svg";